import React from 'react';
import ImageSubmissionPage from '../../../features/off-page/image-submission/ImageSubmissionPage';

interface ImageSubmissionWrapperProps {
  onBack: () => void;
  darkMode: boolean;
}

export default function ImageSubmissionWrapper({ onBack, darkMode }: ImageSubmissionWrapperProps) {
  return <ImageSubmissionPage onBack={onBack} darkMode={darkMode} />;
}
